/* eslint-disable no-useless-escape */
const getDomainFromUrl = url => {
  return url?.replace('https://', '')?.replace('http://', '')?.split('/')?.[0] || url;
};

export default getDomainFromUrl;
